import React, { useEffect, useReducer } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory, useParams } from "react-router-dom";
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';

import ActivityContext from '../../context/activity-context'
import { activityReducer, initialState } from '../../reducers/activity-reducer'
import Loading from '../shared/Loading'
import { DefaultLayout, BreadcrumbsCustom } from '../shared/component'
import useStyles from '../../styles/components/learningcontent/stylesLearningContents'
import { getActivityById, updateActivityCompletionRecord } from '../../actions/activity-actions'
import ActivityDetailContainer from './ActivityDetailContainer'
import AssessmentContainer from './AssessmentContainer'

import { getIconLearningContent } from '../../utils/helpers/icon/iconHelper';
import { getActivityStartTime, setActivityStartTime } from '../../utils/helpers/others/SessionHelper';

function init() {
    return {
        loading: true,
        activity: {},
        alert: {
            severity: '', //error,warning,info,success
            message: ''
        },
        timeTaken: 0,
        tabs: {
            content: true,
            assessment: false,
        },
        multipleChoiceContents: [],
        isSecretCode: false,
        secretCode: '',
        customDialog: {
            open: false,
            message: '',
            severity: 'success',
            isLoading: false
        },
        isTeamActivity:false
    };
}

const ActivityDetail = () => {

    const history = useHistory();
    const classes = useStyles();
    let { memberId, activityId, challengeId } = useParams();
    const [activityContext, dispatch] = useReducer(activityReducer, initialState, init);

    useEffect(() => {
        if (getActivityStartTime() < 1) {
            //dispatch({ type: 'SET_TIMETAKEN', timeTaken: new Date().getTime() });
            setActivityStartTime(new Date().getTime());
            initActivity();
        }

        return () => {
            reportCheatingCase();
        }
    }, []);

    const reportCheatingCase = async () => {
        if (getActivityStartTime() > 0) {
            const endTime = new Date().getTime();
            let duration = Math.round((endTime - getActivityStartTime()) / 1000);
            //console.log("Cheating Detected! Coz press back button", duration);
            let data = {
                ActivityId: activityId,
                MemberId: memberId,
                IsCheating: true,
                TimeTaken: duration
            }
            await updateActivityCompletionRecord(JSON.stringify(data))
            setActivityStartTime(0);
        }
    }

    const initActivity = async () => {
        dispatch({ type: 'SET_LOADING', loading: true });
        const response = await getActivityById(activityId, memberId);


        if (response > 200 || response.status === "Failed") {
            dispatch({ type: 'SET_LOADING', loading: false });
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {
            let activity = response.data;
            //console.log("Activity Detail", activity);
            dispatch({ type: 'SET_ACTIVITY', activity: activity });
            loadAssessment(activity);
        }

    };

    const loadAssessment = (activity) => {

        let questionList = activity.QuestionViewModels;
        let answerHistoryList = activity.OpenEndedAnswerHistory;
        let _multipleChoiceContents = [];
        let _openEndedAnswers = [];
        let _isSecretCode = false;
        let _isTeamActivity = false;


        if (activity.AssessmentType === 'Multiple Choice' || activity.AssessmentType === 'Multiple Choice and Secret Code') {
            questionList.filter(item => item.AssessmentType !== 'Secret Code').map((AssementQuestion) => {
                let multipleChoiceContent = {
                    question: AssementQuestion,
                    answers: AssementQuestion.OptionViewModels,
                    selectedAnswer: {},
                }
                _multipleChoiceContents.push(multipleChoiceContent);
            })
        }
        else if (activity.AssessmentType === 'Multiple Answers' || activity.AssessmentType === 'Multiple Answers and Secret Code') {
            let answers = []
            questionList.filter(item => item.AssessmentType !== 'Secret Code').map((AssementQuestion) => {

                answers = AssementQuestion.OptionViewModels;
                answers.map(item => {
                    item.isChecked = false
                    return item
                })
                let multipleChoiceContent = {
                    question: AssementQuestion,
                    answers,
                    limit: AssementQuestion.Limit
                }
                _multipleChoiceContents.push(multipleChoiceContent);
                
            });
        }else if (activity.AssessmentType === 'Open-ended Answers' || activity.AsessmentType === 'Open-ended Answers and Secret Code') {
            
            questionList.filter(item => item.AssessmentType !== 'Secret Code').map((AssessmentQuestion)=>{
                let answerHistory = [

                ];
                let latestAnswer = '';
                let remarks = '';
                answerHistoryList = answerHistoryList.filter(history=>{
                    if(history.QuestionId === AssessmentQuestion.Id){
                        answerHistory.push(history);
                        if(history.LatestScore){
                            latestAnswer = history.Answer;
                            remarks = history.Remarks;
                        }
                        return false;
                    }else{
                        return true;
                    }
                });
                let openEndedAnswer = {
                    question: AssessmentQuestion,
                    answer: latestAnswer,
                    history: answerHistory,
                    remarks: remarks
                }
                _openEndedAnswers.push(openEndedAnswer);
            })
        }
        else if (activity.AssessmentType === 'Secret Code') {
            _isSecretCode = true;
        }

        _isTeamActivity = activity.IsTeamActivity;

        dispatch({ type:'SET_IS_TEAMACTIVITY', isTeamActivity: _isTeamActivity})
        dispatch({ type: 'SET_IS_SECRETCODE', isSecretCode: _isSecretCode });
        dispatch({ type: 'SET_OPENENDED_ANSWERS', openEndedAnswers : _openEndedAnswers})
        dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: _multipleChoiceContents });
        dispatch({ type: 'SET_LOADING', loading: false });
    }

    const breadcrumbsData = [
        {
            text: 'Challenge',
            href: '/Challenge'
        },
        {
            text: 'Challenge Overview',
            href: `/ChallengeDetail/${challengeId}`
        },
        {
            text: activityContext.activity.ActivityTitle,
            href: ''
        },
    ];

    const handleClickTabs = (item) => {

        switch (item) {
            case "content":
                activityContext.tabs.content = true;
                activityContext.tabs.assessment = false;
                dispatch({ type: 'SET_TABS', tabs: activityContext.tabs });
                break;
            case "assessment":
                activityContext.tabs.content = false;
                activityContext.tabs.assessment = true;
                dispatch({ type: 'SET_TABS', tabs: activityContext.tabs });
                // console.log(activityContext.isTeamActivity)
                break;
        }
    }

    if (activityContext.loading) return <Loading />;

    return (
        <ActivityContext.Provider value={{ activityContext, challengeId, dispatch }}>
            <DefaultLayout
                title={activityContext.activity.ActivityTitle}
                type='Activity'
                description=''
                image={getIconLearningContent().img_lc_bg_header}>
                <Grid container>
                    <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} >
                        <Hidden mdDown>
                            <Grid
                                classes={{ root: classes.rootWrapperTab }}
                                className={clsx(activityContext.tabs.content && classes.rootWrapperTabActive)}
                                container
                                justify="flex-end"
                                onClick={() => handleClickTabs("content")}>
                                <Grid
                                    container
                                    item
                                    lg={12} xl={10}
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridTab }}
                                >
                                    <div className={classes.containerImage}>
                                        <img src="/assets/images/components/challenge/resource.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                    </div>
                                    <div className={classes.containerContent}>
                                        Resource Content
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid
                                classes={{ root: classes.rootWrapperTab }}
                                className={clsx(activityContext.tabs.assessment && classes.rootWrapperTabActive)}
                                container
                                justify="flex-end"
                                onClick={() => handleClickTabs("assessment")}>
                                <Grid
                                    container
                                    item
                                    lg={12} xl={10}
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridTab }}
                                >
                                    <div className={classes.containerImage}>
                                        <img src="/assets/images/components/challenge/assessment.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                    </div>
                                    <div className={classes.containerContent}>
                                        Assessment
                                    </div>
                                </Grid>
                            </Grid>
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} md={9} classes={{ root: classes.rootGridContentContainer }}>
                        <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                        {
                            activityContext.tabs.content ? <ActivityDetailContainer /> : <></>
                        }
                        {
                            activityContext.tabs.assessment ?
                                <>
                                    <Typography classes={{ root: classes.rootTitle }}>Please complete the assessment. {activityContext.isTeamActivity ? "This is a Team Assessment,\
                                    do note that your attempt will represent your team's answers for the assessment and \
                                    block attempts from other teammates until they are marked.":""}</Typography>
                                    <Grid container classes={{ root: classes.rootAssessmentHolder }}>
                                        <AssessmentContainer />
                                    </Grid>
                                </>
                                : <></>
                        }
                    </Grid>
                </Grid>
            </DefaultLayout>
        </ActivityContext.Provider>
    )
}

export default ActivityDetail;